import React,{Component} from 'react';
import OfficeSetupMember  from '../../../components/UI/Member/OfficeSetupMember';
import { Label, Input, Button,Alert , Popover, PopoverHeader, PopoverBody } from 'reactstrap';
import Steps from '../../../components/Steps/Steps';
import { officeSetupSteps } from '../../../utils/constants';
import ErrorMessage from '../../../components/Message/ErrorMessage/ErrorMessage';
import findIndex from 'lodash/findIndex';
import find from 'lodash/find';
import filter from 'lodash/filter';
import axios from '../../../axios';
import * as url from '../../../utils/url';
import { connect } from 'react-redux';
import rightArrow from './../../../assets/arrow-right.png';
import cancelIcon from './../../../assets/cancel.png';
import roundAddIcon from './../../../assets/round-add-button.png';
import { validateEmail } from '../../../utils/validations';
import { planningValues, roleOptions } from '../../../utils/constants';
import { isMobile } from '../../../utils/deviceInfo';
import If from '../../../components/Shared/If';
import Tooltip from '../../../components/UI/TooltipIcon/TooptipIcon';

class AddMembers extends Component {

  constructor(props){
    super(props);
    this.state = {
        shownMembersCount : 3,
        members : [],
        planningValues,
        toggleRoleOpen:false
    };
  }

  handleAddMember = () => {
    const {shownMembersCount} = this.state;
    this.setState({shownMembersCount : shownMembersCount + 1});
  }

  handleMemberDetailsAdded = (id,data) => {
    const {name,value} = data;
    // console.log(id);
    // console.log(data);
    const {members} = this.state;
    let index = findIndex(members,{id : id});
    if(index > -1) {
      members[index][name] = value;
    } else {
      members.push({id : id,[name] : value,role:data.name === 'role' ? data.value : 'Member'});
    }
    this.setState({members : members});
  }

  populateAddMemberInputs = () => {
      let inputs = [];
      const {members} = this.state;
      console.log(this.props)
      for(let i = 0 ; i < this.state.shownMembersCount ; i++) {
          inputs.push(<OfficeSetupMember memberData={find(members,{id : i})} id={i} key={i}
            onInputChange={this.handleMemberDetailsAdded} {...this.props}/>);
      }
      return inputs;
  }

  handleContinue = () => {
    let members = Array.from(this.state.members);
    const {orgAdmin} = this.props.user;
    const invalidMembers = filter(members,(member) => {
      if(member.email === undefined || member.email.length === 0 ) {
        if(member.role === 'Admin') {
          return true;
        }
      }
      return false;
    })
    const invalidEmail = filter(members,(member) => {
      if(!validateEmail(member.email)) {
        return true;
      }
    })
    if(members.length === 0) {
      this.setState({error: true, errorMessage: 'Please enter details to invite members or click "Skip" to continue.'});
      // this.props.history.push('/home/activity');
      return;
    }
    if(invalidEmail.length > 0) {
      this.setState({error: true, errorMessage: 'Please enter a valid email.'});
      return;
    }
    if(invalidMembers.length > 0) {
      window.scroll(0,0);
      this.setState({error: true, errorMessage: 'Please enter a valid email.'});
      return;
    }else {
      this.setState({
        error : false
      })
    }
    members = members.filter(member => member.email && member.email!=='' && member.email.trim()!=='');
    if(members.length === 0) {
      this.setState({error: true, errorMessage: 'Please enter details to invite members.'});
      return;
    }
    const payload = {data : members};
    axios.post(url.addMembers,payload).then((response) => {
      if(response) {
        if(orgAdmin) {
          this.props.history.push('/setup/upload-data-landing');
        } else {
          this.props.history.push('/home/stories');
        }
      }
    }).catch((error) => {
      if(error && error.response && error.response.data.errors.error) {
        let errorString = error.response.data.errors.error.toString();
        this.setState({error: true, errorMessage:  errorString.replace(/,/g, ', ')+ ' ' + error.response.data.errors.message});
      } else{
        this.setState({error: true, errorMessage: 'Failed to add invite members.'});
      }
    });
  }

  handleSkip = () => {
    const {orgAdmin} = this.props.user;
    if(orgAdmin) {
      this.props.history.push('/setup/upload-data-landing');
    } else {
      this.props.history.push('/home/stories');
    }
  }

  toggleRoleInfo = () => {
    this.setState({ toggleRoleOpen: !this.state.toggleRoleOpen });
  }

  render(){
    // console.log(this.state.members);
    const {error, errorMessage} = this.state;
    console.log(this.props)
    let urlPath = this.props.location.pathname?this.props.location.pathname:this.props.match.path?this.props.match.path:this.props.match.url
    let {role}=this.props.user
    let alert = null;
    if(error) {
      alert = <div className="mt20"><ErrorMessage message={errorMessage}/></div>
    }
    return(
      <div className="page-title-box">
        <If condition={!isMobile}>
          <div className="title-text">Invite Others to this Workspace</div>
         
         {urlPath.indexOf('invite')===-1?
          <Steps
          steps={officeSetupSteps}
          currentStep={3}
        />
         :null}
         

        </If>
        <div className="text-primary-color setup-content mb40">
              Invite your officemates to the platform by inputting their login information below and assigning them
              roles.{role==='Member'? <span> As a Member, you can invite other Admins, Users, and other Members. </span>:
              role==='User'? <span> As a User, you can invite Admins, others Users, Members. </span>: <span> As an Admin, you can invite other Admins, Users or Members. </span>}
              <span> For more info on roles and privileges, click here 
            <span id="toggleRoleOpen-popover" className="mlRBACInfo" onClick={()=>this.toggleRoleInfo()}><Tooltip /></span>.
              <Popover placement="right" isOpen={this.state.toggleRoleOpen} target="toggleRoleOpen-popover" toggle={()=>this.toggleRoleInfo()}>
                <PopoverHeader className="popover-header-tooltip">
                  Roles and Privileges
                </PopoverHeader>
                <PopoverBody className="popover-body-tooltip">
                  {roleOptions.map( (e, idx)=>{
                    return <p key={idx}>{e.label}: {e.definition} </p>
                  })}
                  
                </PopoverBody>
              </Popover> 
            </span>
        </div>
        {
          error ? alert: null
        }
        <div className="row">
            <div className="col">
                <Label for="role" className="field-lable" style={{float:'left'}}>Role</Label>
            </div>
            <div className="col">
                <Label for="email" className="field-lable" style={{float:'left'}}>Email</Label>
            </div>
            <If condition={!isMobile}>
              <div className="col">
                  <Label for="firstName" className="field-lable" style={{float:'left'}}>First Name
                  <span className="optional-text" style={{fontSize:'16px',lineHeight:'22px'}}> (Optional)</span></Label>
              </div>
              <div className="col">
                  <Label for="lastName" className="field-lable" style={{float:'left'}}>Last Name
                  <span className="optional-text" style={{fontSize:'16px',lineHeight:'22px'}}> (Optional)</span></Label>
              </div>
            </If>
        </div>
        {
            this.populateAddMemberInputs()
        }
        <div className="row" style={{marginTop:20}}>
            <div className="col cursor-pointer" onClick={this.handleAddMember}>
              <img style={{marginRight:'10px'}} src={roundAddIcon} height="20px" width="20px" />
                <a className="add-member-link">Add another</a>
            </div>
        </div>
        <div className="row mb10 mt40">
          <div className="col-md-3">
            <Button
              className={`${isMobile && 'mb-4'} float-left goBackBtn w100`}
              onClick={() => {
                // this.props.history.push('/setup/office-details')
                this.props.history.push('/setup/personal-details')
                }}>
              <span className="goBackBtnTxt">
                <span className="ml10 flaticon-back"/> Go Back</span>
            </Button>
          </div>
          <div className="col">
              <Button color="primary"
              onClick={this.handleContinue}
              className={`${isMobile && 'mb-4'} btn-continue`}>
              Continue<img style={{marginLeft:'10px'}} src={rightArrow} height="25px" width="25px" /></Button>

              <Button color={'secondary-filled'}
                  onClick={this.handleSkip}
                  className="btn-skip">
                <img style={{marginRight:'10px'}} src={cancelIcon} height="20px" width="20px" /><span>Skip</span></Button>
            </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
	return {
    user : state.user.profile
	}
}

export default connect(mapStateToProps)(AddMembers);
